import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Company Settings
export const getCompanySettings = () => axios.get(`${API}/company`);
export const updateCompanySettings = (data) => axios.put(`${API}/company`, data);
export const uploadLogo = (file, type = "main") => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${API}/company/logo?logo_type=${type}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// Customers
export const getCustomers = (params) => axios.get(`${API}/customers`, { params });
export const getCustomer = (id) => axios.get(`${API}/customers/${id}`);
export const createCustomer = (data) => axios.post(`${API}/customers`, data);
export const updateCustomer = (id, data) => axios.put(`${API}/customers/${id}`, data);
export const deleteCustomer = (id) => axios.delete(`${API}/customers/${id}`);

// Catalog
export const getCatalogItems = (params) => axios.get(`${API}/catalog`, { params });
export const getCatalogItem = (id) => axios.get(`${API}/catalog/${id}`);
export const createCatalogItem = (data) => axios.post(`${API}/catalog`, data);
export const updateCatalogItem = (id, data) => axios.put(`${API}/catalog/${id}`, data);
export const deleteCatalogItem = (id) => axios.delete(`${API}/catalog/${id}`);

// Documents
export const getDocuments = (params) => axios.get(`${API}/documents`, { params });
export const getDocument = (id) => axios.get(`${API}/documents/${id}`);
export const createDocument = (data) => axios.post(`${API}/documents`, data);
export const updateDocument = (id, data) => axios.put(`${API}/documents/${id}`, data);
export const validateDocument = (id) => axios.post(`${API}/documents/${id}/validate`);
export const convertQuote = (id) => axios.post(`${API}/documents/${id}/convert`);
export const duplicateDocument = (id) => axios.post(`${API}/documents/${id}/duplicate`);
export const deleteDocument = (id) => axios.delete(`${API}/documents/${id}`);
export const forceDeleteDocument = (id) => axios.delete(`${API}/documents/${id}?force=true`);
export const cancelDocument = (id) => axios.post(`${API}/documents/${id}/cancel`);
export const createDepositInvoice = (quoteId, data) => axios.post(`${API}/documents/${quoteId}/deposit-invoice`, data);
export const createBalanceInvoice = (quoteId) => axios.post(`${API}/documents/${quoteId}/balance-invoice`);
export const getQuoteDeposits = (quoteId) => axios.get(`${API}/documents/${quoteId}/deposits`);
export const getDocumentPdf = (id, download = false) => 
  axios.get(`${API}/documents/${id}/pdf?download=${download}`, { responseType: "blob" });

// Payments
export const getPayments = (params) => axios.get(`${API}/payments`, { params });
export const createPayment = (data) => axios.post(`${API}/payments`, data);
export const deletePayment = (id) => axios.delete(`${API}/payments/${id}`);
export const cancelAllPayments = (documentId) => axios.delete(`${API}/payments/document/${documentId}/all`);

// Credit Notes & Rectification
export const createCreditNoteFromInvoice = (invoiceId, data) => 
  axios.post(`${API}/documents/${invoiceId}/credit-note`, data);
export const rectifyInvoice = (invoiceId) => 
  axios.post(`${API}/documents/${invoiceId}/rectify`);
export const getInvoiceLinesForCredit = (invoiceId) => 
  axios.get(`${API}/documents/${invoiceId}/lines-for-credit`);

// Dashboard
export const getDashboard = () => axios.get(`${API}/dashboard`);

// Statistics
export const getSalesStats = (params) => axios.get(`${API}/stats/sales`, { params });
export const getTopClients = (params) => axios.get(`${API}/stats/top-clients`, { params });
export const getTopProducts = (params) => axios.get(`${API}/stats/top-products`, { params });
export const getClientStats = (customerId) => axios.get(`${API}/stats/client/${customerId}`);
export const getProductStats = (productName) => axios.get(`${API}/stats/product/${encodeURIComponent(productName)}`);
export const getStatsSummary = (params) => axios.get(`${API}/stats/summary`, { params });
export const getAllTimeStats = () => axios.get(`${API}/stats/all-time`);
export const getKpis = () => axios.get(`${API}/stats/kpis`);

// Quote status change
export const changeQuoteStatus = (docId, status) => axios.post(`${API}/documents/${docId}/status`, { status });

// Exports
export const exportInvoicesCsv = (params) => 
  axios.get(`${API}/exports/invoices-csv`, { params, responseType: "blob" });
export const exportCustomersCsv = () => 
  axios.get(`${API}/exports/customers-csv`, { responseType: "blob" });
export const exportJournalCsv = (params) => 
  axios.get(`${API}/exports/journal-csv`, { params, responseType: "blob" });
export const exportBackupJson = () => 
  axios.get(`${API}/exports/backup-json`, { responseType: "blob" });
export const exportEinvoice = (id) => 
  axios.get(`${API}/exports/einvoice/${id}`, { responseType: "blob" });

// Users Management (Admin only)
export const getUsers = () => axios.get(`${API}/users`);
export const getUser = (id) => axios.get(`${API}/users/${id}`);
export const createUser = (data) => axios.post(`${API}/users`, data);
export const updateUser = (id, data) => axios.put(`${API}/users/${id}`, data);
export const deleteUser = (id) => axios.delete(`${API}/users/${id}`);
export const getRolesAndTabs = () => axios.get(`${API}/users/roles/list`);
export const getUserRoles = () => axios.get(`${API}/users/roles/list`);

// Audit Logs (Admin only)
export const getAuditLogs = (params) => axios.get(`${API}/audit-logs`, { params });
export const getEntityHistory = (entityType, entityId) => 
  axios.get(`${API}/audit-logs/entity/${entityType}/${entityId}`);

// Recurring Invoices
export const getRecurringInvoices = (params) => axios.get(`${API}/recurring-invoices`, { params });
export const getRecurringInvoice = (id) => axios.get(`${API}/recurring-invoices/${id}`);
export const createRecurringInvoice = (data) => axios.post(`${API}/recurring-invoices`, data);
export const updateRecurringInvoice = (id, data) => axios.put(`${API}/recurring-invoices/${id}`, data);
export const deleteRecurringInvoice = (id) => axios.delete(`${API}/recurring-invoices/${id}`);
export const pauseRecurringInvoice = (id) => axios.post(`${API}/recurring-invoices/${id}/pause`);
export const resumeRecurringInvoice = (id) => axios.post(`${API}/recurring-invoices/${id}/resume`);
export const stopRecurringInvoice = (id) => axios.post(`${API}/recurring-invoices/${id}/stop`);
export const generateRecurringInvoiceNow = (id) => axios.post(`${API}/recurring-invoices/${id}/generate-now`);

// Notifications
export const getNotifications = (params) => axios.get(`${API}/notifications`, { params });
export const getUnreadNotificationCount = () => axios.get(`${API}/notifications/unread-count`);
export const markNotificationAsRead = (id) => axios.post(`${API}/notifications/${id}/read`);
export const markAllNotificationsAsRead = () => axios.post(`${API}/notifications/read-all`);
export const deleteNotification = (id) => axios.delete(`${API}/notifications/${id}`);
export const clearAllNotifications = () => axios.delete(`${API}/notifications/clear-all`);

// E-Invoicing
export const getEInvoiceStatus = (docId) => axios.get(`${API}/documents/einvoice/${docId}/status`);
export const getEInvoiceHistory = (docId) => axios.get(`${API}/documents/einvoice/${docId}/history`);
export const prepareEInvoice = (docId) => axios.post(`${API}/documents/einvoice/${docId}/prepare`);
export const transmitEInvoice = (docId) => axios.post(`${API}/documents/einvoice/${docId}/transmit`);
export const getEInvoiceXml = (docId) => axios.get(`${API}/documents/einvoice/${docId}/xml`, { responseType: "blob" });
export const testPdpConnection = () => axios.post(`${API}/documents/einvoice/test-connection`);

// Communication Subscriptions
export const getSubscriptions = (params) => axios.get(`${API}/subscriptions`, { params });
export const getSubscription = (id) => axios.get(`${API}/subscriptions/${id}`);
export const getSubscriptionStats = () => axios.get(`${API}/subscriptions/stats`);
export const getSubscriptionsBillingDue = () => axios.get(`${API}/subscriptions/billing-due`);
export const createSubscription = (data) => axios.post(`${API}/subscriptions`, data);
export const createSubscriptionsBatch = (data) => axios.post(`${API}/subscriptions/batch`, data);
export const updateSubscription = (id, data) => axios.put(`${API}/subscriptions/${id}`, data);
export const pauseSubscription = (id, data = {}) => axios.post(`${API}/subscriptions/${id}/pause`, data);
export const resumeSubscription = (id, data = {}) => axios.post(`${API}/subscriptions/${id}/resume`, data);
export const stopSubscription = (id, data = {}) => axios.post(`${API}/subscriptions/${id}/stop`, data);
export const deleteSubscription = (id) => axios.delete(`${API}/subscriptions/${id}`);
export const generateSubscriptionInvoice = (id, period) => axios.post(`${API}/subscriptions/${id}/generate-invoice`, { period });
export const skipSubscriptionPeriod = (id, period) => axios.post(`${API}/subscriptions/${id}/skip-period`, { period });

// Push Notifications (PWA)
export const getVapidPublicKey = () => axios.get(`${API}/push/vapid-public-key`);
export const subscribePush = (data) => axios.post(`${API}/push/subscribe`, data);
export const unsubscribePush = (data) => axios.post(`${API}/push/unsubscribe`, data);
export const sendTestPush = () => axios.post(`${API}/push/test`);

// Content Calendars (Communication)
export const getCalendars = (params) => axios.get(`${API}/calendars`, { params });
export const getCalendarSubscriptions = () => axios.get(`${API}/calendars/subscriptions`);
export const getCalendarAgenda = (params) => axios.get(`${API}/calendars/agenda`, { params });
export const getEventAttachments = (eventId) => axios.get(`${API}/attendance/events/${eventId}/files`);
export const eventAttachmentUrl = (eventId, fileId) => `${API}/attendance/events/${eventId}/files/${fileId}/content`;
export const downloadEventAttachment = (eventId, fileId, signal) => axios.get(eventAttachmentUrl(eventId, fileId), { responseType: "blob", signal });
export const uploadEventAttachment = (eventId, file, onUploadProgress, signal) => {
  const body = new FormData(); body.append("file", file);
  return axios.post(`${API}/attendance/events/${eventId}/files`, body, { onUploadProgress, signal });
};
export const deleteEventAttachment = (eventId, fileId) => axios.delete(`${API}/attendance/events/${eventId}/files/${fileId}`);
export const createCalendar = (data) => axios.post(`${API}/calendars`, data);
export const getCalendar = (id) => axios.get(`${API}/calendars/${id}`);
export const updateCalendar = (id, data) => axios.put(`${API}/calendars/${id}`, data);
export const deleteCalendar = (id) => axios.delete(`${API}/calendars/${id}`);
export const createCalendarPost = (calId, data) => axios.post(`${API}/calendars/${calId}/posts`, data);
export const updateCalendarPost = (calId, postId, data) => axios.put(`${API}/calendars/${calId}/posts/${postId}`, data);
export const deleteCalendarPost = (calId, postId) => axios.delete(`${API}/calendars/${calId}/posts/${postId}`);
export const aiGenerateCalendar = (calId, data) => axios.post(`${API}/calendars/${calId}/ai-generate`, data, { timeout: 180000 });
export const getCalendarPdf = (calId) => axios.get(`${API}/calendars/${calId}/pdf`, { responseType: "blob" });

// Communication Stats
export const getSubscriptionBillingStats = (params) => axios.get(`${API}/subscriptions/billing-stats`, { params });
export const getCalendarStats = (params) => axios.get(`${API}/calendars/stats`, { params });

// Push Notification Settings
export const getPushSettings = () => axios.get(`${API}/push/settings`);
export const updatePushSettings = (data) => axios.put(`${API}/push/settings`, data);

// Employees
export const getEmployees = () => axios.get(`${API}/employees`);

// Attendance / RH (planning, événements, absences)
export const getSchedules = () => axios.get(`${API}/attendance/schedules`);
export const updateEmployeeSchedule = (employeeId, days, schoolWeeks) => axios.put(`${API}/attendance/schedule/${employeeId}`, { days, school_weeks: schoolWeeks });
export const getPlanningWeek = (weekStart) => axios.get(`${API}/attendance/planning`, { params: weekStart ? { week_start: weekStart } : {} });
export const getPlanningMonth = (month) => axios.get(`${API}/attendance/planning-month`, { params: { month } });
export const getPlanningYear = (year) => axios.get(`${API}/attendance/planning-year`, { params: { year } });
export const getAvailability = (date) => axios.get(`${API}/attendance/availability`, { params: { date } });
export const getPlanningEvents = (start, end) => axios.get(`${API}/attendance/events`, { params: { start, end } });
export const createPlanningEvent = (data) => axios.post(`${API}/attendance/events`, data);
export const updatePlanningEvent = (id, data) => axios.put(`${API}/attendance/events/${id}`, data);
export const deletePlanningEvent = (id) => axios.delete(`${API}/attendance/events/${id}`);
export const getEventTypes = () => axios.get(`${API}/attendance/event-types`);
export const createEventType = (data) => axios.post(`${API}/attendance/event-types`, data);
export const updateEventType = (id, data) => axios.put(`${API}/attendance/event-types/${id}`, data);
export const deleteEventType = (id) => axios.delete(`${API}/attendance/event-types/${id}`);
export const getAbsences = (params) => axios.get(`${API}/attendance/absences`, { params });
export const createAbsence = (data) => axios.post(`${API}/attendance/absences`, data);
export const updateAbsence = (id, data) => axios.put(`${API}/attendance/absences/${id}`, data);
export const deleteAbsence = (id) => axios.delete(`${API}/attendance/absences/${id}`);
export const getControlCenter = (date) => axios.get(`${API}/attendance/control-center`, { params: date ? { date } : {} });
export const getMyPlanning = (start, end) => axios.get(`${API}/attendance/my-planning`, { params: { start, end } });
export const respondToEvent = (id, action) => axios.post(`${API}/attendance/events/${id}/respond`, { action });
export const finishEvent = (id) => axios.post(`${API}/attendance/events/${id}/finish`);
export const resumeEvent = (id) => axios.post(`${API}/attendance/events/${id}/resume`);
export const getAbsenceAttachments = (id) => axios.get(`${API}/attendance/absences/${id}/attachments`);
export const uploadAbsenceAttachment = (id, formData) => axios.post(`${API}/attendance/absences/${id}/attachments`, formData, { headers: { "Content-Type": "multipart/form-data" } });
export const downloadAbsenceAttachment = (fileId) => axios.get(`${API}/attendance/absence-files/${fileId}/download`, { responseType: "blob" });
export const deleteAbsenceAttachment = (fileId) => axios.delete(`${API}/attendance/absence-files/${fileId}`);

// ============ MATÉRIEL (Inventaire) ============
export const getEquipmentCategories = () => axios.get(`${API}/equipment/categories`);
export const createEquipmentCategory = (data) => axios.post(`${API}/equipment/categories`, data);
export const deleteEquipmentCategory = (id) => axios.delete(`${API}/equipment/categories/${id}`);
export const getEquipment = (params) => axios.get(`${API}/equipment`, { params });
export const createEquipment = (data) => axios.post(`${API}/equipment`, data);
export const updateEquipment = (id, data) => axios.put(`${API}/equipment/${id}`, data);
export const deleteEquipment = (id) => axios.delete(`${API}/equipment/${id}`);
export const getEquipmentStats = () => axios.get(`${API}/equipment/stats`);
export const checkoutEquipment = (id, data) => axios.post(`${API}/equipment/${id}/checkout`, data);
export const returnEquipmentMovement = (id, data) => axios.post(`${API}/equipment/movements/${id}/return`, data);
export const getEquipmentMovements = (params) => axios.get(`${API}/equipment/movements`, { params });
export const getMovementPhotos = (id) => axios.get(`${API}/equipment/movements/${id}/photos`);
export const uploadMovementPhoto = (id, formData) => axios.post(`${API}/equipment/movements/${id}/photos`, formData, { headers: { "Content-Type": "multipart/form-data" } });
export const downloadMovementPhoto = (fileId) => axios.get(`${API}/equipment/movement-files/${fileId}/download`, { responseType: "blob" });
export const deleteMovementPhoto = (fileId) => axios.delete(`${API}/equipment/movement-files/${fileId}`);
export const createRentalQuote = (movementId) => axios.post(`${API}/equipment/movements/${movementId}/create-quote`);
export const globalSearch = (q) => axios.get(`${API}/search`, { params: { q } });
export const getEmployee = (id) => axios.get(`${API}/employees/${id}`);
export const createEmployee = (data) => axios.post(`${API}/employees`, data);
export const updateEmployee = (id, data) => axios.put(`${API}/employees/${id}`, data);
export const deleteEmployee = (id) => axios.delete(`${API}/employees/${id}`);
export const uploadEmployeeFile = (id, formData) => axios.post(`${API}/employees/${id}/files`, formData);
export const getEmployeeFiles = (id, params) => axios.get(`${API}/employees/${id}/files`, { params });
export const downloadEmployeeFile = (fileId) => axios.get(`${API}/employees/files/${fileId}/download`, { responseType: "blob" });
export const deleteEmployeeFile = (fileId) => axios.delete(`${API}/employees/files/${fileId}`);
export const getEmployeeShifts = (id, params) => axios.get(`${API}/employees/${id}/shifts`, { params });
export const createEmployeeShift = (id, data) => axios.post(`${API}/employees/${id}/shifts`, data);
export const updateEmployeeShift = (shiftId, data) => axios.put(`${API}/employees/shifts/${shiftId}`, data);
export const deleteEmployeeShift = (shiftId) => axios.delete(`${API}/employees/shifts/${shiftId}`);
export const getDirectoryCategories = () => axios.get(`${API}/directory/categories`);
export const createDirectoryCategory = (data) => axios.post(`${API}/directory/categories`, data);
export const updateDirectoryCategory = (id, data) => axios.put(`${API}/directory/categories/${id}`, data);
export const deleteDirectoryCategory = (id) => axios.delete(`${API}/directory/categories/${id}`);
export const getDirectoryTags = () => axios.get(`${API}/directory/tags`);
export const createDirectoryTag = (data) => axios.post(`${API}/directory/tags`, data);
export const deleteDirectoryTag = (id) => axios.delete(`${API}/directory/tags/${id}`);
export const getDirectoryContacts = (params) => axios.get(`${API}/directory/contacts`, { params });
export const getDirectoryContact = (id) => axios.get(`${API}/directory/contacts/${id}`);
export const createDirectoryContact = (data) => axios.post(`${API}/directory/contacts`, data);
export const updateDirectoryContact = (id, data) => axios.put(`${API}/directory/contacts/${id}`, data);
export const deleteDirectoryContact = (id) => axios.delete(`${API}/directory/contacts/${id}`);
export const checkDirectoryDuplicates = (params) => axios.get(`${API}/directory/contacts/check-duplicates`, { params });
export const toggleDirectoryFavorite = (id) => axios.post(`${API}/directory/contacts/${id}/favorite`);
export const getDirectoryContactHistory = (id) => axios.get(`${API}/directory/contacts/${id}/history`);
export const getDirectoryFacets = () => axios.get(`${API}/directory/facets`);
export const getMyProfile = () => axios.get(`${API}/employees/my-profile`);
export const getEmployeeSchedule = (employeeId) => axios.get(`${API}/attendance/schedule/${employeeId}`);
export const parseSchoolCalendar = (employeeId, formData) => axios.post(`${API}/attendance/schedule/${employeeId}/school-calendar/parse`, formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 180000 });
export const applySchoolDates = (employeeId, data) => axios.put(`${API}/attendance/schedule/${employeeId}/school-dates`, data);
export const applyCalendarOverrides = (employeeId, data) => axios.put(`${API}/attendance/schedule/${employeeId}/calendar-overrides`, data);
export const setDayException = (employeeId, data) => axios.put(`${API}/attendance/schedule/${employeeId}/day-exception`, data);
export const downloadEventCallsheet = (eventId) => axios.get(`${API}/attendance/events/${eventId}/callsheet`, { responseType: "blob" });
export const getTasks = () => axios.get(`${API}/tasks`);
export const getTask = (id) => axios.get(`${API}/tasks/${id}`);
export const createTask = (data) => axios.post(`${API}/tasks`, data);
export const updateTask = (id, data) => axios.put(`${API}/tasks/${id}`, data);
export const deleteTask = (id) => axios.delete(`${API}/tasks/${id}`);
export const addTaskComment = (id, text) => axios.post(`${API}/tasks/${id}/comments`, { text });
export const getMyAbsences = () => axios.get(`${API}/attendance/absences/mine`);
